// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10064":"b03e4f41","19742":"b03e4f41","23383":"7e020c72","31712":"b03e4f41","51339":"b03e4f41","61250":"b03e4f41","76297":"b03e4f41","77566":"b03e4f41","94446":"b03e4f41"}[chunkId] + ".chunk.css";
};